

















import UserAdministrationList from "@/components/partner/UserAdministrationList.vue";
import UserAdministrationDetail from "@/components/partner/UserAdministrationDetail.vue";
import TheLayoutPortalSplit from "@/layouts/TheLayoutPortalSplit.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { Component } from "vue-property-decorator";
import UserAdministrationListPaginated from "@/components/partner/UserAdministrationListPaginated.vue";
import Vue from "vue";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import { FeatureModule } from "@/store/modules/feature.store";

@Component({
  components: {
    TheLayoutPortalSplit,
    UserAdministrationList,
    UserAdministrationListPaginated,
    UserAdministrationDetail
  }
})
export default class UserAdministration extends PartnerFallbackMixin {
  loadingSelectedUser = false;

  /**
   * Returns information on if the user and all the data that is associated to it but saved seperately outside of the user doc is loaded
   */
  get _loadingSelectedUserOrBanking() {
    return this.loadingSelectedUser || this.bankingLoading;
  }
  set _loadingSelectedUserOrBanking(loadingSelectedUser: boolean) {
    this.loadingSelectedUser = loadingSelectedUser;
  }

  /**
   * Information of banking is loaded (banking is loaded seperately from user)
   * if we do not await this we may have inconsistencies after switching back and forth between user documents in the list quickly
   * when banking loading is true, the elements in the list of the user-administration-list are disabled, so you can not switch users until everything is done loading
   */
  bankingLoading = false;
  setBankingLoading(bankingLoading: boolean) {
    this.bankingLoading = bankingLoading;
  }

  setLoadingSelectedUser(isLoading: any) {
    this.loadingSelectedUser = isLoading;
  }

  get isPaginationUserEnabled() {
    return FeatureModule.isPaginationUserEnabled;
  }

  //------------ CODE REQUIRED FOR NON - PAGINATION ------------
  loadingAllUsers = false;
  get getLoadingAllUsers() {
    return this.loadingAllUsers;
  }
  get getLoadingSelectedUser() {
    return this.loadingSelectedUser;
  }
  async mounted() {
    if (!this.isPaginationUserEnabled) {
      await this.refresh();
    }
  }
  async refresh() {
    this.loadingAllUsers = true;
    this.loadingSelectedUser = true;
    await this.trySetByRouteOrDefault();
    const users = await UserAdministrationModule.getUsers();
    this.loadingAllUsers = false;
    if (!users) {
      Vue.$toast.error("Nutzer konnten nicht gefunden werden");
    } else {
      const user = await UserAdministrationModule.getSelectedUser(users[0]._id);
      if (!user) {
        Vue.$toast.error("Der Ausgewählte Nutzer konnte nicht geladen werden.");
      }
    }
    this.loadingSelectedUser = false;
  }
  //------------------------------------------------------------
}
